'use client'

import { APP_VERSION } from "@/constants/version";

const Home = () => {
  console.log("APP_VERSION", APP_VERSION);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
      <h1>Welcome to BuildYou</h1>
    </div>
  );
};
export default Home;
